webpackJsonp([216664578383465],{

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tagPageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(73);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagsPage = function TagsPage(_ref) {
	  var _ref$data = _ref.data,
	      group = _ref$data.allMarkdownRemark.group,
	      title = _ref$data.site.siteMetadata.title;
	  return _react2.default.createElement(
	    'section',
	    { className: 'section' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Tags | ' + title }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'column is-10 is-offset-1',
	            style: { marginBottom: '6rem' }
	          },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title is-size-2 is-bold-light' },
	            'Tags'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'taglist' },
	            group.map(function (tag) {
	              return _react2.default.createElement(
	                'li',
	                { key: tag.fieldValue },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/tags/' + (0, _lodash.kebabCase)(tag.fieldValue) + '/' },
	                  tag.fieldValue,
	                  ' (',
	                  tag.totalCount,
	                  ')'
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = TagsPage;
	var tagPageQuery = exports.tagPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tags-index-js-c274925bf732519b0815.js